import React, { Component } from 'react';
import { InputLabel, Required } from 'styles/common';
import { translate } from 'react-i18next';
import SelectList from 'react-widgets/lib/SelectList';

// Styles
import {
  Dropdown,
  ErrorMessage,
  MS_CommonWrapper,
  MS_CheckBox
} from './styles';

class MultiSelectFieldWithTicks extends Component {
  constructor(props) {
    super(props);
    const {
      defaultValue,
      input: { value }
    } = props;
    const startArray = (defaultValue instanceof Array && defaultValue) || value;
    this.state = {
      selectValues: startArray ? startArray : []
    };
    this.renderSelectList = this.renderSelectList.bind(this);
    this.renderListItem = this.renderListItem.bind(this);
    this.renderTextField = this.renderTextField.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  onChangeValue(value) {
    const { onChange, input, valueField } = this.props;
    const _value = valueField
      ? value.map(_item => _item && _item[valueField])
      : value;
    this.setState({
      selectValues: _value
    });
    if (onChange) {
      onChange(_value);
    }
    if (input && input.onChange) {
      input.onChange(_value);
      input.onBlur(_value);
    }
  }

  renderListItem(params) {
    const { selectValues } = this.state;
    const { textField, valueField } = this.props;
    const isChecked = valueField
      ? String(selectValues).indexOf(String(params.item[valueField])) > -1
      : String(selectValues).indexOf(String(params.value)) > -1;

    return (
      <MS_CheckBox isChecked={isChecked}>
        <div className="icon" />
        <p>{textField ? params.item[textField] : params.text}</p>
      </MS_CheckBox>
    );
  }

  renderSelectList() {
    const { data, defaultValue, valueField, input } = this.props;
    let _defaultValue = [];
    if (defaultValue && data && valueField) {
      _defaultValue = defaultValue.forEach(_defV => {
        const searchRes = data.find(_d => _d[valueField] === _defV);
        if (searchRes) _defaultValue.push(_defaultValue);
      });
    } else if (input && input.value) {
      _defaultValue = input.value.forEach(_defV => {
        const searchRes = data.find(_d => _d[valueField] === _defV);
        if (searchRes) _defaultValue.push(_defaultValue);
      });
    }

    return (
      <SelectList
        data={data}
        multiple
        defaultValue={_defaultValue}
        onChange={this.onChangeValue}
        itemComponent={this.renderListItem}
      />
    );
  }

  renderTextField() {
    const { selectValues } = this.state;
    const { textField, valueField, data } = this.props;

    let _arr = [];
    if (data) {
      if (textField && valueField) {
        _arr = selectValues.map(_el => {
          const _find = data.find(_insEl => _insEl[valueField] === _el);
          if (_find) {
            return _find[textField];
          }
        });
      } else {
        _arr = [...selectValues];
      }
    }
    return _arr.join(', ');
  }

  render() {
    const {
      i18n,
      input,
      label,
      placeholder,
      isRequired,
      meta: { touched, error },
      open,
      onToggle,
      data
    } = this.props;
    
    return (
      <MS_CommonWrapper haveData={data} error={touched && error}>
        <InputLabel className="input-label">
          {label}
          {isRequired && <Required> *</Required>}
        </InputLabel>

        <Dropdown
          {...input}
          open={open}
          textField={this.renderTextField}
          onSearch={() => {}}
          placeholder={placeholder}
          error={touched && error}
          onToggle={onToggle}
          messages={{
            emptyList: data ? this.renderSelectList : null
          }}
          onBlur={() => {}}
        />
        {touched && error && (
          <ErrorMessage>
            {typeof error === 'string' && i18n.t(error)}
          </ErrorMessage>
        )}
      </MS_CommonWrapper>
    );
  }
}

export default translate()(MultiSelectFieldWithTicks);
